// relative
import { apiSlice } from '../../apiSlice';

export const alarmsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['Alarm', 'AlarmTypes'],
  endpoints: (builder) => ({
    getAlarmsByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Alarms?orderbydesc=Created&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['Alarm'],
    }),
    getAlarmsFeedByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Alarms/Feed?orderby=Created&Account.AccountId=eq(${accountId})&top=10000`,
        };
      },
      providesTags: ['Alarm'],
    }),
    getAlarms: builder.query({
      query: () => {
        return {
          url: `/Alarms?orderbydesc=Created&State=eq(Unresolved)&top=2000`,
        };
      },
      providesTags: ['Alarm'],
    }),
    updateAlarm: builder.mutation({
      query: (args) => {
        const { alarmId, alarm } = args;
        return {
          url: `/Alarms/${alarmId}`,
          method: 'PATCH',
          body: alarm,
        };
      },
      invalidatesTags: ['Alarm'],
    }),
    getAlarmTypes: builder.query({
      query: () => {
        return {
          url: `/AlarmTypes`,
        };
      },
      providesTags: ['AlarmTypes'],
    }),
    getAlarmById: builder.query({
      query: (args) => {
        const alarmId = args;
        return {
          url: `/Alarms/${alarmId}`,
        };
      },
      providesTags: ['Alarm'],
    }),
  }),
});

export const {
  useGetAlarmsByAccountQuery,
  useGetAlarmsFeedByAccountQuery,
  useGetAlarmTypesQuery,
  useGetAlarmsQuery,
  useUpdateAlarmMutation,
  useGetAlarmByIdQuery,
} = alarmsApiSlice;
